<script>
export default {
  name: 'AdminTableSearch',
  props: {
    totalLabel: { type: String, required: true },
    totalNum: { type: Number, required: true },
    noNewBtn: { type: Boolean, required: false, default: false },
    tableType: { type: String, required: false, default: null },
    noFilterOption: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      nameFilter: '',
      emailFilter: '',
    }
  },
  methods: {
    setFilterParams() {
      let params = {}
      if (this.nameFilter) {
        params = { name: this.nameFilter }
      }
      if (this.tableType === 'USERS' && this.emailFilter) {
        params = Object.assign(params, { email: this.emailFilter })
      }
      this.$emit('set-filter-params', params)
    },
    goAddItem() {
      this.$emit('go-add-item')
    },
  },
}
</script>

<template>
  <div class="flex justify-between p-4 items-center">
    <div class="pl-4 flex items-center">
      {{ totalLabel }} {{ totalNum }}
      <button
        v-if="!noNewBtn"
        class="button secondary-button text-left px-6 text-lg"
        @click="goAddItem"
      >
        + Add new
      </button>
    </div>
    <div v-if="!noFilterOption" class="flex">
      <div class="flex items-center">
        <label for="nameSearch" class="mr-3">Name:</label>
        <input
          v-model="nameFilter"
          type="text"
          name="nameSearch"
          class="border rounded-full border-gray w-56 h-sm focus:outline-none px-3"
          @input="setFilterParams"
        />
      </div>
      <div v-if="tableType === 'USERS'" class="flex items-center">
        <label for="emailSearch" class="ml-8 mr-3">Email:</label>
        <input
          v-model="emailFilter"
          type="text"
          name="emailSearch"
          class="border rounded-full border-gray w-56 h-sm focus:outline-none px-3"
          @input="setFilterParams"
        />
      </div>
    </div>
  </div>
</template>
